// libraries
import React from "react";
import { Link } from "react-router-dom";

// styles
import styles from "./styles.module.scss";

// assets
import logo from "../../../assets/images/logo/logo.svg";

// components
import Info from "../Info/Info";
import FormContent from "../Forms/Content";
import GradientBall from "../GradientBall/GradientBall";

const Content = ({ initailIndex = 1 }) => {
  return (
    <div className={styles.content}>
      <div className={styles.head}>
        <GradientBall
          size="medium"
          style={{ position: "absolute", left: "144px" }}
        />
        <Link to="/">
          <img src={logo} alt="logo" />
        </Link>
      </div>
      <div className={styles.body}>
        <Info />
        <FormContent initailIndex={initailIndex} />
      </div>
    </div>
  );
};

export default Content;
